import React from 'react'

const SDT = () => {
  return (

    <div className='skills__content'>
    <h3 className='skills__title'> Statistical & Data mining techniques</h3>

    <div className='skill__box'>
        <div className='skills__group'>
            <div className='skills__data'>
            <i class='bx bx-math'></i>
                            <div>
                    <h3 className='skills__name'>GLM</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-math'></i>
                            <div>
                    <h3 className='skills__name'>Trees</h3>
                    <span className='skills__level'> </span>
                </div>
            </div>
            
            <div className='skills__data'>
            <i class='bx bx-math'></i>                <div>
                    <h3 className='skills__name'>Boosting</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-math'></i>                <div>
                    <h3 className='skills__name'>Text-mining
</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
        </div>
        <div className='skills__group'>
          
            <div className='skills__data'>
            <i class='bx bx-math'></i>                <div>
                    <h3 className='skills__name'>Weeka</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-math'></i>                <div>
                    <h3 className='skills__name'>Flink</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-math'></i>                <div>
                    <h3 className='skills__name'>Storm</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-math'></i>                <div>
                    <h3 className='skills__name'>ETC</h3>
                </div>
            </div>
            
        </div>
        
    </div>
</div>

  )
}

export default SDT